import { render, staticRenderFns } from "./MemList.vue?vue&type=template&id=3277b470&scoped=true"
import script from "./MemList.vue?vue&type=script&lang=js"
export * from "./MemList.vue?vue&type=script&lang=js"
import style0 from "./MemList.vue?vue&type=style&index=0&id=3277b470&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3277b470",
  null
  
)

export default component.exports